<script>
import axios from "axios";
import Swal from "sweetalert2";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { menuItems } from "@/components/menu-static";
import api from "../../../helpers/api";

function joinApiUrl(baseUrl, path) {
  return `${String(baseUrl || "").replace(/\/+$/, "")}/${String(path || "").replace(/^\/+/, "")}`;
}

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      form_captcha: false,
      lanjut_validasi: true,
      is_one_time: false,
      captcha: "",
      hitungan_1: Math.floor(Math.random() * 9) + 1,
      hitungan_2: Math.floor(Math.random() * 9) + 1,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      configuration: [],
      errLogin: false,
      errLoginMsg: false,
    };
  },
  validations: {
    username: {
      required: helpers.withMessage("Username is required", required),
    },
    password: {
      required: helpers.withMessage("Password is required", required),
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    // get konfigurasi
    let self = this;

    if (localStorage.getItem("session")) {
      self.$router.push({ name: "dashboard" });
    }

    var config_login = {
      method: "get",
      url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/konfig-login",
      headers: {
        Accept: "application/json",
      },
    };
    axios(config_login)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          self.configuration = response_data_fix.referensi;
          // if (response_data_fix.referensi.CAPTCHA == "Tidak") {
          //   self.form_captcha = false;
          // } else {
          self.form_captcha = true;
          // }

          if (response_data_fix.referensi.ONE_TIME_LOGIN == "Tidak") {
            self.is_one_time = false;
          } else {
            self.is_one_time = true;
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    resetCatpcha() {
      this.hitungan_1 = Math.floor(Math.random() * 9) + 1;
      this.hitungan_2 = Math.floor(Math.random() * 9) + 1;
    },
    async tryToLogIn() {
      let self = this;
      this.errLogin = false;
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {
        Swal.fire({
          title: '<i class="fas fa-spinner fa-spin"></i>',
          text: "Loading...",
          showConfirmButton: false,
        });

        if (self.form_captcha) {
          var jumlah_captcha = self.hitungan_1 + self.hitungan_2;
          if (jumlah_captcha != self.captcha) {
            self.lanjut_validasi = false;
          } else {
            self.lanjut_validasi = true;
          }
        }

        if (self.lanjut_validasi == false) {
          // Swal.fire({
          //   icon: "warning",
          //   title: "Opps",
          //   text: "Captcha Salah!!!",
          //   timer: 1000,
          //   timerProgressBar: true,
          //   showCancelButton: false,
          //   showConfirmButton: false,
          // });
          this.errLogin = true;
          this.errLoginMsg = "Captcha Salah";
          this.resetCatpcha();
          Swal.close();
        } else {
          try {
            await api.get("csrf-cookie");
            const response = await api.post("auth/login", {
              username: this.username,
              password: this.password,
              is_one_time: this.is_one_time,
            });

            var data_login = response.data.data;
            // check status login
            if (data_login.status_login == false) {
              // Swal.fire({
              //   icon: "warning",
              //   title: "Oopss",
              //   text: data_login.message_login,
              //   showCancelButton: false,
              //   showConfirmButton: true,
              // });
              this.errLogin = true;
              this.errLoginMsg = data_login.message_login;
              this.resetCatpcha();
              Swal.close();
            } else {
              // inisialisasi variabel localstorage untuk session
              localStorage.setItem(
                "session_user_id",
                response.data.data.user.user_id,
              ); // session user id
              localStorage.setItem(
                "session_username",
                response.data.data.user.username,
              ); // session username
              localStorage.setItem(
                "session_name",
                response.data.data.user.name,
              ); // session name
              localStorage.setItem(
                "session_path_photo",
                response.data.data.user.path_photo,
              ); // session path photo
              localStorage.setItem(
                "access_token",
                response.data.data.access_token,
              ); // akses token
              localStorage.setItem(
                "session_role",
                JSON.stringify(response.data.data.role),
              ); // session role
              localStorage.setItem(
                "session_role_active_id",
                response.data.data.role[0].role.id_role,
              ); // session role active id
              localStorage.setItem(
                "session_role_active_name",
                response.data.data.role[0].role.role_name,
              ); // session role active name
              localStorage.setItem("session_role_active_index", 0); // session role active index
              localStorage.setItem(
                "session_menu_access",
                JSON.stringify(response.data.data.menu_access[0].role_menu),
              ); // set session meu access user
              localStorage.setItem(
                "session",
                JSON.stringify(response.data.data),
              ); // set all response to session
              localStorage.setItem("user", response.data.data.user); // set session user
              localStorage.setItem(
                "configuration",
                JSON.stringify(self.configuration),
              ); // set session configuration
              localStorage.setItem("reload_already", "no");
              localStorage.setItem("dateLogin", Date.now());
              localStorage.setItem(
                "roles_data_akses_menu",
                response.data.data.roles_data_akses.menu,
              );
              localStorage.setItem(
                "roles_data_akses_kode_tes",
                response.data.data.roles_data_akses.kode_tes,
              );
              localStorage.setItem(
                "is_validator",
                response.data.data.is_validator,
              );
              localStorage.setItem(
                "is_penyusunSoal",
                response.data.data.is_penyusun_soal,
              );
              if (response.data.data.penyusun_soal) {
                localStorage.setItem(
                  "penyusunSoal",
                  JSON.stringify(response.data.data.penyusun_soal),
                );
              } else {
                localStorage.removeItem("penyusunSoal");
              }

              // get role cermat
              try {
                await self.getRoleCermat(
                  response.data.data.access_token,
                  response.data.data.user.username,
                );
                console.log("getRoleCermat done");
              } catch (err) {
                console.error("getRoleCermat failed:", err);
              }

              await Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Anda akan diarahkan ke halaman dashboard segera",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              });

              if (
                localStorage.session &&
                localStorage.session_name &&
                localStorage.access_token
              ) {
                await this.$router.replace({ name: "dashboard" });
              }
            }
          } catch (error) {
            console.log({ error });
            var message =
              error.response?.data?.data?.error ||
              error.response?.data?.message ||
              error.message ||
              "Terjadi Kesalahan, Coba lagi nanti";
            if (message == "Session has been used") {
              // Swal.fire({
              //   icon: "error",
              //   title: "Oops...",
              //   text: "Akun anda telah login di perangkat lain, silahkan logout terlebih dahulu!",
              // });
              message =
                "Akun anda telah login di perangkat lain, silahkan logout terlebih dahulu!";
            } else if (message == "Account cant find") {
              // Swal.fire({
              //   icon: "error",
              //   title: "Oops...",
              //   text: "Periksa Kembali Username & Password Anda!",
              // });
              message = "Periksa Kembali Username & Password Anda!";
            } else if (message == "Something went wrong") {
              // Swal.fire({
              //   icon: "error",
              //   title: "Oops...",
              //   text: "Terjadi Kesalahan, Coba lagi nanti",
              // });
              message = "Terjadi Kesalahan, Coba lagi nanti";
            } else {
              // Swal.fire({
              //   icon: "error",
              //   title: "Oops...",
              //   text: "Akun tidak ditemukan, periksa kembali username & password anda",
              // });
              message =
                "Akun tidak ditemukan, periksa kembali username & password anda";
            }

            this.errLogin = true;
            this.errLoginMsg = message;
            this.resetCatpcha();
            Swal.close();
          }
        }
      }
    },
    async getRoleCermat(token, nip) {
      try {
        const response = await axios.get(
          joinApiUrl(process.env.VUE_APP_API_CERMAT, "role_cermat"),
          {
            headers: {
              Authorization: "Bearer " + token,
              Cookie: "ci_session=fp3neb9nmgfgqi4qt87b2c79ujfn9on0",
            },
            params: {
              nip: nip,
            },
          },
        );
        const menuRead = response.data.response_get.menuRead ?? [];
        const menuWrite = response.data.response_get.menuWrite ?? [];
        const nameRoleCermat = response.data.response_get.namaRole;
        const nameLabels = menuRead.map((item) => item.name);
        const nameWriteLabels = menuWrite.map((item) => item.name);

        const filteredMenuItems = await menuItems
          .map((item) => {
            // dashboard
            if (item.label == "Dashboard") {
              return item;
            }

            // Filter subItems jika ada
            if (item.subItems) {
              const filteredSubItems = item.subItems.filter(function (subItem) {
                const noCheck = subItem.noCheck ?? false;
                return nameLabels.includes(subItem.label) || noCheck;
              });
              return filteredSubItems.length > 0
                ? { ...item, subItems: filteredSubItems }
                : null;
            }

            // Kembalikan item utama jika label ada di nameLabels
            if (nameLabels.includes(item.label) || item.noCheck) {
              return item;
            }

            // Jika tidak ada kecocokan, kembalikan undefined
            return null;
          })
          .filter((item) => item !== null);

        // Menu Penyusun Soal, Validator, dan Kompetensi Validator hanya untuk
        // user yang BUKAN validator dan BUKAN penyusun soal.
        const isValidator = localStorage.getItem("is_validator") === "true";
        const isPenyusunSoal =
          localStorage.getItem("is_penyusunSoal") === "true";
        const restrictedLabels = [
          "Penyusun Soal",
          "Validator",
          "Kompetensi Validator",
        ];

        const visibleMenuItems =
          isValidator || isPenyusunSoal
            ? filteredMenuItems
                .filter((item) => !restrictedLabels.includes(item.label))
                .map((item) =>
                  item.subItems
                    ? {
                        ...item,
                        subItems: item.subItems.filter(
                          (subItem) =>
                            !restrictedLabels.includes(subItem.label),
                        ),
                      }
                    : item,
                )
            : filteredMenuItems;

        let filteredNameRoute = [];
        visibleMenuItems.forEach((item) => {
          filteredNameRoute.push(item.label);
          if (item.subItems) {
            item.subItems.forEach((subItem) => {
              filteredNameRoute.push(subItem.label);
            });
          }
        });

        localStorage.setItem("filtered_name_menu", filteredNameRoute);
        localStorage.setItem("role_cermat", nameRoleCermat);
        localStorage.setItem(
          "filtered_menu",
          JSON.stringify(visibleMenuItems),
        );
        localStorage.setItem("menu_read_names", JSON.stringify(nameLabels));
        localStorage.setItem(
          "menu_write_names",
          JSON.stringify(nameWriteLabels),
        );
        console.log("filteredMenuItems", visibleMenuItems);
      } catch (error) {
        console.error("Error fetching role cermat:", error);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div class="col-xl-9">
          <div class="auth-full-bg pt-lg-5 p-4">
            <div class="w-100">
              <div
                class="bg-overlay"
                v-bind:style="{
                  background: `url(${require('@/assets/images/bg_login.jpeg')})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no repeat',
                  backgroundPosition: 'center',
                }"
              ></div>
            </div>
          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-3">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="mb-5 mb-md-0">
                  <center>
                    <router-link to="/login" class="d-block auth-logo">
                      <!-- <img
                        :src="configuration.LOGO_FULL_DARK"
                        v-bind:alt="configuration.APPLICATION_FULL_NAME"
                        height="35"
                        class="auth-logo-dark"
                      />
                      <img
                        :src="configuration.LOGO_FULL_LIGHT"
                        v-bind:alt="configuration.APPLICATION_FULL_NAME"
                        height="35"
                        class="auth-logo-light"
                      /> -->
                      <img
                        src="@/assets/images/logo_pln_caption.png"
                        height="150"
                      />
                    </router-link>
                  </center>
                </div>
                <div class="my-auto">
                  <div>
                    <h5 class="text-primary">Selamat Datang</h5>
                    <p class="text-muted">
                      Masuk dengan username dan password anda.
                    </p>
                  </div>
                  <b-alert
                    v-model="isAuthError"
                    variant="danger"
                    class="mt-3"
                    dismissible
                    >{{ authError }}</b-alert
                  >

                  <div
                    v-if="notification.message"
                    :class="'alert ' + notification.type"
                  >
                    {{ notification.message }}
                  </div>
                  <div class="mt-4">
                    <div v-if="errLogin" class="alert alert-danger">
                      {{ errLoginMsg }}
                    </div>
                    <b-form @submit.prevent="tryToLogIn">
                      <div class="row">
                        <div class="col-lg-12">
                          <b-form-group
                            class="mb-3"
                            id="input-group-1"
                            label="Username"
                            label-for="input-1"
                          >
                            <b-form-input
                              id="input-1"
                              v-model="username"
                              type="text"
                              placeholder="Masukkan Username"
                              :class="{
                                'is-invalid': submitted && v$.username.$error,
                              }"
                            ></b-form-input>
                            <div
                              v-for="(item, index) in v$.username.$errors"
                              :key="index"
                              class="invalid-feedback"
                            >
                              <span v-if="item.$message">{{
                                item.$message
                              }}</span>
                            </div>
                          </b-form-group>
                        </div>

                        <div class="col-lg-12">
                          <b-form-group
                            class="mb-3"
                            id="input-group-2"
                            label="Password"
                            label-for="input-2"
                          >
                            <b-input-group>
                              <b-form-input
                                id="input-2"
                                v-model="password"
                                :type="showPassword ? 'text' : 'password'"
                                placeholder="Masukkan Password"
                                :class="{
                                  'is-invalid': submitted && v$.password.$error,
                                }"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  @click="showPassword = !showPassword"
                                  variant="outline-secondary"
                                >
                                  <span v-if="showPassword">
                                    <i class="fas fa-eye-slash"></i>
                                  </span>
                                  <span v-else>
                                    <i class="fas fa-eye"></i>
                                  </span>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <div
                              v-if="submitted && v$.password.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="v$.password.required.$message">{{
                                v$.password.required.$message
                              }}</span>
                            </div>
                          </b-form-group>
                        </div>

                        <div class="col-lg-12" v-if="form_captcha">
                          <b-form-group
                            class="mb-3"
                            id="input-group-3"
                            label="Captcha"
                            label-for="input-3"
                          >
                            <div class="row">
                              <div class="col-md-4" style="padding-right: 0">
                                <b-form-input
                                  id="input-3"
                                  type="text"
                                  :placeholder="hitungan_1 + ' + ' + hitungan_2"
                                  :disabled="true"
                                ></b-form-input>
                              </div>
                              <div class="col-md-8" style="padding-left: 5px">
                                <b-form-input
                                  id="input-4"
                                  v-model="captcha"
                                  type="number"
                                  placeholder="Masukkan Captcha"
                                  :required="true"
                                ></b-form-input>
                              </div>
                            </div>
                          </b-form-group>
                        </div>

                        <div class="col-lg-12">
                          <div class="mt-3 d-grid">
                            <b-button
                              type="submit"
                              variant="primary"
                              class="btn-block"
                              >Log In</b-button
                            >
                          </div>
                        </div>
                      </div>
                    </b-form>
                  </div>
                </div>

                <div class="mt-4 mt-md-5 text-center">
                  <p class="mb-0">
                    Copyright ©
                    {{ new Date().getFullYear() }}
                    PLN Corpu - UPS. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
  </div>
</template>
